<div class="mini-box">
  <div class="mini-box-content">
    <div class="title">{{title}}</div>
    <div class="subtitle">{{subtitle}}</div>
    <hr class="line">
    <a *ngIf="!authService.isLoggedIn()" (click)="authService.signIn('signup')" class="signup-link">Sign Up ></a>
  </div>
</div>